export default __webpack_public_path__ + "static/145-945622ebe9abb0482ec2bc496c2c2acb.jpg";